import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Amplitude from '../../utils/amplitudeHelper'
import routes from '../../routes'
import config from '../../config'
import { showGlobalModal } from 'src/ducks/layout'
import { GlobalModalTypes } from 'src/components/GlobalModals/GlobalModalContainer'
import { fixedAssets, mobileAssets } from 'src/containers/PreCache'
import NoticeBar from 'src/components/NoticeBar'
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa'
import { toast } from 'react-toastify'
import Svg from 'src/components/Svg'
import usePageAccess, { PageEnum } from 'src/utils/usePageAccess'
import luckyDrawIcon from 'src/images/pve/lottery-game-mobile.png'

const MobileLobby = ({ currentUser }) => {
  usePageAccess({ currentUser, page: PageEnum.Lobby })
  const scrollRef = useRef(null)
  const history = useHistory()
  const dispatch = useDispatch()
  let { search } = useLocation()
  const query = new URLSearchParams(search)
  const toastMsg = query.get('message')
  useEffect(() => {
    toast(toastMsg, { toastId: 'auditoriumClosed' })
  }, [toastMsg])

  useEffect(() => {
    document.title = `${config.eventName} | Lobby`
    Amplitude.visit('Lobby')
    window.chaport.q('hideLauncher')
  }, [currentUser.id])

  const showHelpDesk = () => {
    const cpt = window.chaport
    cpt.on('ready', function () {
      cpt.setVisitorData({
        name: currentUser.fullName,
        email: currentUser.email,
      })
      cpt.open()
    })
    cpt.on('collapsed', function () {
      cpt.close()
    })
    Amplitude.clickHelpDesk()
  }

  const handleScrollLeft = () => {
    const { scrollLeft } = scrollRef.current

    // Determine the scroll distance for this action
    const scrollDistance = Math.min(300, scrollLeft)

    // Scroll by the calculated distance
    scrollRef.current.scrollBy({
      left: -scrollDistance,
      behavior: 'smooth',
    })
  }

  const handleScrollRight = () => {
    const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current

    // Calculate the remaining scroll distance
    const maxScrollLeft = scrollWidth - clientWidth
    const remainingScrollDistance = maxScrollLeft - scrollLeft

    // Determine the scroll distance for this action
    const scrollDistance = Math.min(300, remainingScrollDistance)

    // Scroll by the calculated distance
    scrollRef.current.scrollBy({
      left: scrollDistance,
      behavior: 'smooth',
    })
  }

  const onItemBoxClickHandler = (route, external = false) => {
    if (!route) return

    if (external) {
      window.open(route, '_blank')
    } else {
      history.push(route)
    }
  }

  return (
    <Page>
      <NoticeBar />

      <div className="wrap">
        <div className="top">
          <div className="masthead">
            <img src={mobileAssets.landingBgMobile} alt="Masthead" />
          </div>
        </div>
        <div className="content">
          <div className="menu">
            <div className="d-flex justify-content-center align-items-center px-3">
              <p className="title">Virtual Hall</p>
            </div>

            <div className="list-wrapper" ref={scrollRef}>
              <div className="item-box" onClick={() => onItemBoxClickHandler(routes.auditorium)}>
                <div className="icon-wrapper">
                  <Svg icon="hall" />
                  {/* <img className="menu-icon" src={mobileAssets.mobileAuditoriumIcon} alt="icon" /> */}
                </div>
                <p className="item-label">Auditorium Hall</p>
              </div>

              <div className="item-box" onClick={() => dispatch(showGlobalModal(GlobalModalTypes.Agenda))}>
                <div className="icon-wrapper">
                  <Svg icon="programme" />
                </div>
                <p className="item-label">Programme & Speakers</p>
                {/* <div onClick={() => dispatch(showGlobalModal(GlobalModalTypes.Agenda))} className="item-button">
                  Enter
                </div> */}
              </div>

              {/* <div className="item-box" onClick={() => onItemBoxClickHandler(routes.game)}>
                <div className="icon-wrapper">
                  <Svg icon="game" />
                </div>
                <p className="item-label game">Fast & Furious Top 30</p>
              </div> */}

              <div className="item-box" onClick={() => onItemBoxClickHandler(routes.networking)}>
                <div className="icon-wrapper">
                  <Svg icon="networking" />
                </div>
                <p className="item-label">Networking</p>
              </div>

              {/*<div className="item-box" onClick={() => dispatch(showGlobalModal(GlobalModalTypes.Speakers))}>
                <div className="icon-wrapper">
                  <svg width="59" height="52" viewBox="0 0 59 52" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M46.0886 43.6533C46.7815 43.7101 47.4823 43.7391 48.19 43.7391C51.1247 43.7391 53.9422 43.2404 56.5615 42.3235C56.5792 42.102 56.5882 41.8782 56.5882 41.6522C56.5882 37.0418 52.8282 33.3043 48.19 33.3043C46.433 33.3043 44.8021 33.8406 43.4538 34.7575M46.0886 43.6533C46.0888 43.6819 46.0888 43.7105 46.0888 43.7391C46.0888 44.3652 46.0541 44.9832 45.9866 45.5914C41.0687 48.3963 35.3689 50 29.2923 50C23.2157 50 17.5159 48.3963 12.598 45.5914C12.5304 44.9832 12.4958 44.3652 12.4958 43.7391C12.4958 43.7106 12.4958 43.6821 12.496 43.6536M46.0886 43.6533C46.072 40.3794 45.1075 37.3283 43.4538 34.7575M43.4538 34.7575C40.4699 30.1188 35.2424 27.0435 29.2923 27.0435C23.3429 27.0435 18.116 30.118 15.132 34.7558M15.132 34.7558C13.7841 33.84 12.1541 33.3043 10.3983 33.3043C5.76003 33.3043 2 37.0418 2 41.6522C2 41.8782 2.00903 42.102 2.02676 42.3235C4.64599 43.2404 7.46353 43.7391 10.3983 43.7391C11.1047 43.7391 11.8043 43.7102 12.496 43.6536M15.132 34.7558C13.4775 37.3271 12.5125 40.3788 12.496 43.6536M37.6906 10.3478C37.6906 14.9582 33.9305 18.6957 29.2923 18.6957C24.6541 18.6957 20.894 14.9582 20.894 10.3478C20.894 5.73745 24.6541 2 29.2923 2C33.9305 2 37.6906 5.73745 37.6906 10.3478ZM54.4871 18.6957C54.4871 22.1534 51.667 24.9565 48.1884 24.9565C44.7097 24.9565 41.8897 22.1534 41.8897 18.6957C41.8897 15.2379 44.7097 12.4348 48.1884 12.4348C51.667 12.4348 54.4871 15.2379 54.4871 18.6957ZM16.6949 18.6957C16.6949 22.1534 13.8749 24.9565 10.3962 24.9565C6.91754 24.9565 4.09751 22.1534 4.09751 18.6957C4.09751 15.2379 6.91754 12.4348 10.3962 12.4348C13.8749 12.4348 16.6949 15.2379 16.6949 18.6957Z"
                      stroke="white"
                      stroke-width="4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <p className="item-label">Speakers</p>
                 <div onClick={() => dispatch(showGlobalModal(GlobalModalTypes.Speakers))} className="item-button">
                  Enter
                </div> 
              </div>*/}

              <div className="item-box" onClick={() => onItemBoxClickHandler(routes.onDemand)}>
                <div className="icon-wrapper">
                  <Svg icon="gallery" />
                </div>
                <p className="item-label">Gallery</p>
              </div>

              {/* <div className="item-box" onClick={() => onItemBoxClickHandler(routes.survey, true)}>
                <div className="icon-wrapper">
                  <svg width="38" height="54" viewBox="0 0 38 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_3_12)">
                      <path
                        d="M37.2002 3.33228C36.6936 2.82191 35.9885 2.52761 35.2685 2.52761H29.078V0.840054C29.078 0.618399 28.989 0.402332 28.8331 0.245869C28.6754 0.0894071 28.4601 0 28.2393 0H10.1504C9.92958 0 9.71247 0.0894071 9.5566 0.245869C9.40072 0.402332 9.31165 0.618399 9.31165 0.840054V2.52761H2.73152C2.01152 2.52761 1.30638 2.82005 0.79793 3.33228C0.291337 3.84264 0 4.54858 0 5.27129V51.2563C0 51.979 0.291337 52.685 0.799785 53.1953C1.30823 53.7076 2.01152 54 2.73337 54H35.2685C35.9885 54 36.6918 53.7076 37.2002 53.1953C37.7087 52.685 38.0019 51.979 38.0019 51.2563V5.27129C38.0019 4.54858 37.7105 3.84264 37.2002 3.33228ZM10.9892 1.68197H27.4024V2.52761H10.9892V1.68197ZM10.9892 6.19889H27.4024V7.97027H10.9892V6.19889ZM35.2685 48.5126V49.8314H2.73152V6.19889H9.31165V8.81032C9.31165 9.03197 9.40072 9.24804 9.5566 9.4045C9.71247 9.56097 9.92958 9.65037 10.1504 9.65037H28.2393C28.4601 9.65037 28.6754 9.56097 28.8331 9.4045C28.989 9.24804 29.078 9.03197 29.078 8.81032V6.19889H35.2685V48.5126Z"
                        fill="white"
                      />
                      <path d="M32.5332 12.3921H5.46484V15.3109H32.5332V12.3921Z" fill="white" />
                      <path d="M32.5332 18.9971H5.46484V21.9158H32.5332V18.9971Z" fill="white" />
                      <path d="M32.5332 25.6021H5.46484V28.5208H32.5332V25.6021Z" fill="white" />
                      <path d="M32.5332 32.207H5.46484V35.1258H32.5332V32.207Z" fill="white" />
                      <path d="M32.5332 38.812H5.46484V41.7308H32.5332V38.812Z" fill="white" />
                    </g>
                    <defs>
                      <clipPath id="clip0_3_12">
                        <rect width="38" height="54" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <p className="item-label">Survey</p>
              </div> */}

              <div className="item-box" onClick={showHelpDesk}>
                <div className="icon-wrapper">
                  <Svg icon="helpdesk" />
                </div>
                <p className="item-label">Help Desk</p>
              </div>

              {/* <div className="item-box" onClick={() => dispatch(showGlobalModal(GlobalModalTypes.LuckyDraw))}>
                <div className="icon-wrapper">
                  <img src={luckyDrawIcon} alt="Lucky Draw" width="40" height="40" />
                </div>
                <p className="item-label">Lucky Draw</p>
              </div> */}
            </div>

            <div className="lobby-controls">
              <button className="scroll-btn left" onClick={handleScrollLeft}>
                <img src={mobileAssets.scrollRightIcon} alt="Scroll Right" />
              </button>
              <button className="scroll-btn" onClick={handleScrollRight}>
                <img src={mobileAssets.scrollRightIcon} alt="Scroll Right" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}

const Page = styled.div`
  height: 100dvh;
  overflow-y: scroll;

  p.game {
    font-size: 13px;
  }

  .scroll-btn {
    appearance: none;
    outline: none;
    border: none;
    background: none;
    cursor: pointer;
    transition: transform 0.1s ease-in-out;

    &:active {
      transform: scale(0.9);
    }

    &.left {
      transform: rotate(180deg);

      &:active {
        transform: rotate(180deg) scale(0.9);
      }
    }
  }
  .organizer-header {
    background: #fff;
    display: inline-flex;
    align-items: center;
    padding: 9px;
    gap: 1rem;
    border-bottom-right-radius: 10px;
    margin-bottom: 1rem;
    align-self: start;

    p {
      margin: 0;
      font-size: 8px;
      font-weight: 500;
      letter-spacing: 0.24px;
    }

    img {
      max-width: 106px;
    }
  }

  .lobby-controls {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 0 1rem 1rem 1rem;
    gap: 2rem;
  }

  .wrap {
    display: flex;
    flex-direction: column;
    height: calc(100% - 35px);
    background: url(${mobileAssets.mobileBg});
    background-size: cover;
    background-position: bottom;
    gap: 0;
  }

  .top {
    display: flex;
    /* flex: 1 0 auto; */
    /* max-height: 45%; */
    position: relative;
    flex-direction: column;
  }

  .organizer-logo {
    position: absolute;
    top: -2px;
    left: -5px;
    max-width: 123px;
    img {
      width: 100%;
    }
  }

  .content {
    background: url(${mobileAssets.lobbyBgMobile});
    /* padding-top: 26%; */
    color: #fff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    flex: 1 1 0;
    min-height: 380px;
  }

  .flex-1 {
    flex: 1 0 auto;
  }

  .masthead {
    img {
      width: 100%;
    }
  }

  .menu-icon {
    width: 100%;
  }
  .outer-wrapper {
    height: 100%;
    /* background-color: rgba(209, 219, 226, 1); */
  }
  .menu {
    width: 100%;
    height: 100%;
    position: relative;
    padding-inline: 16px;
    padding-top: 16px;
    padding-bottom: 8px;
    /*background: rgba(255, 255, 255, 0.6);*/
    backdrop-filter: blur(6px);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
  }
  .title {
    font-size: 28px;
    font-weight: bold;
    margin: 0;
  }
  .btn-container {
    display: flex;
  }
  #moreBtn {
    width: 80px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    em {
      font-size: 14px;
      margin-right: 8px;
    }
  }
  .list-wrapper {
    width: 100%;
    height: 160px;
    /* position: absolute; */
    top: 45px;
    left: 0;
    /* margin-inline: 1rem; */
    overflow-x: scroll;
    display: flex;
    align-items: center;
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    margin-top: 1rem;
    margin-bottom: 1rem;
    scroll-snap-type: x mandatory; /* Enable snapping to avoid extra scrolling */
  }

  .item-box {
    width: 130px;
    height: 160px;
    margin-left: 20px;
    border: solid 3px var(--blue-01);
    border-radius: 10px;
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    scroll-snap-align: start;
    gap: 10px;
    background: var(--blue-01);
    color: #fff;
  }
  .icon-wrapper {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .item-label {
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    margin: 0px;
  }
  .item-button {
    background: var(--gradient-purple);
    color: var(--yellow);
    border: none;
    border-radius: 30px;
    font-size: 12px;
    font-weight: bold;
    width: 90px;
    height: 25px;
    margin: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media screen and (min-width: 540px) {
    .menu {
      height: 250px;
    }
    .list-wrapper {
      top: 65px;
    }
    .outer-wrapper {
      width: 540px;
      margin: auto;
    }
  }
`

export default MobileLobby
